<template>
  <div class="big mydialog">
    <div class="page_title">角色与权限</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div class="searchbox">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="AddRole"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('14') : false
            "
            >添加角色</el-button
          >
        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%;min-width:1000px;"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column prop="group_name" label="角色名"></el-table-column>
            <el-table-column
              prop="sensitive_str"
              label="敏感字段"
              width="300"
            >
              <template slot-scope="scope">
                <div>
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    width="200"
                    :content="scope.row.sensitive_str">
                    <div slot="reference" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                      {{ scope.row.sensitive_str }}
                    </div>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="desc" label="角色描述"></el-table-column>
            <el-table-column label="关联用户数量">
              <template slot-scope="scope">
                <div class="rolenum" @click="roleNum(scope.row.group_id)">
                  {{ scope.row.admin_count }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="400">
              <template slot-scope="scope">
                <el-button
                  @click="checkRole(scope.row)"
                  type="text"
                  size="medium"
                  v-if="scope.row.group_id == 1"
                  >查看权限</el-button
                >

                <el-button
                  @click="editRole(scope.row)"
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0] ? !module_id_array.includes('15') : false
                  "
                  v-if="scope.row.group_id != 1"
                  >编辑</el-button
                >

                <el-button
                  @click="delRole(scope.row.group_id)"
                  type="text"
                  size="medium"
                  v-if="scope.row.group_id != 1"
                  :disabled="
                    module_id_array[0] ? !module_id_array.includes('13') : false
                  "
                  >删除</el-button
                >

                <el-button
                  @click="setRole(scope.row)"
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0] ? !module_id_array.includes('17') : false
                  "
                  v-if="scope.row.group_id != 1"
                  >权限设置</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="addrole"
      @close="closeDig"
      width="580px"
      :close-on-click-modal="false"
    >
      <div class="myform">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="角色名" prop="group_name">
            <el-input
              v-model="ruleForm.group_name"
              placeholder="请输入10位以内汉字或字符"
              maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item label="敏感字段" prop="sensitive_array">
            <div style="text-align: left;">
              <el-tag
                :key="tag"
                v-for="tag in dynamicTags"
                :disable-transitions="false"
                style="margin-right: 15px;"
              >
                {{ tag }}
              </el-tag>
            </div>
            <div
              style="border: solid 1px #c9cbd6;height: 300px;overflow-y: scroll;"
            >
              <el-table
                ref="sensitivemultipleTable"
                :data="sensitiveTableData"
                style="width: 100%;"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column label="字段名" width="120">
                  <template slot-scope="scope">{{
                    scope.row.column_name
                  }}</template>
                </el-table-column>
                <el-table-column label="字段脱敏规则">
                  <template slot-scope="scope">{{
                    scope.row.column_desc
                  }}</template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
          <el-form-item label="角色描述" prop="desc">
            <el-input
              type="textarea"
              v-model="ruleForm.desc"
              placeholder="20字以内"
              maxlength="20"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align:left;padding:0 0 30px 100px">
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="submit('ruleForm')"
            style="width:92px"
            size="medium"
            >保 存</el-button
          >
        </span>
      </div>
    </el-dialog>

    <el-dialog
      title="外部管理员-关联用户"
      :visible.sync="rolenum"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="adminbox">
        <div class="admintitle">
          <div class="name">用户名</div>
          <div class="desc">用户描述</div>
          <div class="status">状态</div>
        </div>
        <div class="adminitem" v-for="(item, index) in adminList" :key="index">
          <div class="name">{{ item.user_name }}</div>
          <div class="desc">{{ item.desc }}</div>
          <div class="status" v-if="item.user_status">正常</div>
          <div class="status" v-else>锁定</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import system from "../../../api/system";
import _ from "lodash";

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      adminList: [],
      tableData: [],
      addrole: false,
      title: "添加角色",
      rolenum: false,
      ruleForm: {
        group_name: "",
        desc: "",
      },
      rules: {
        group_name: [
          {
            required: true,
            message: "请输入10位以内汉字或字符",
            trigger: "blur",
          },
          { max: 10, message: "请输入10位以内汉字或字符", trigger: "blur" },
        ],
      },
      sensitiveTableData: [],
      multipleSelection: [],
      dynamicTags: [],
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取角色列表
    getAdminGroup() {
      let page = this.currentPage;
      let pageNumber = this.pagesize;
      system
        .getAdminGroupList({ page, pageNumber })
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取
    getConfig() {
      system.getColumnConfig().then((res) => {
        if (res.code == 0) {
          this.sensitiveTableData = res.data.list;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.dynamicTags = val.map((res) => {
        return res.column_name;
      });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getAdminGroup();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getAdminGroup();
    },
    //添加角色按钮
    AddRole() {
      this.title = "添加角色";
      this.ruleForm = {
        group_name: "",
        desc: "",
      };
      this.addrole = true;
    },
    //添加/编辑 角色
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let group_name = this.ruleForm.group_name;
          let desc = this.ruleForm.desc;
          let sensitive_array = this.multipleSelection
            .map((el) => {
              return el.column_key;
            })
            .join();
          const data = {
            group_name,
            desc,
            sensitive_array,
          };
          console.log('data',data);
          if (this.title == "添加角色") {
            system
              .addAdminGroup(data)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success("添加成功");
                  this.addrole = false;
                  this.getAdminGroup();
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            let group_id = this.ruleForm.group_id;
            const data1 = {
              group_name,
              desc,
              group_id,
              sensitive_array,
            };
            system
              .editAdminGroup(data1)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success("修改成功");
                  this.addrole = false;
                  this.getAdminGroup();
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //修改角色按钮
    editRole(row) {
      this.title = "编辑角色";
      this.addrole = true;
      this.ruleForm = {
        group_name: row.group_name,
        desc: row.desc,
        group_id: row.group_id,
      };
      // 处理回显
      const sensitiveArray = (row.sensitive_array || "").split(",");
      const arr = this.sensitiveTableData.filter((item) => {
        return sensitiveArray.some((i) => item.column_key == i);
      });
      this.multipleSelection = arr;
      this.dynamicTags = this.multipleSelection.map((res) => {
        return res.column_name;
      });
      setTimeout(() => {
        arr.forEach((e) => {
          this.$refs.sensitivemultipleTable.toggleRowSelection(e);
        });
      }, 1000);
    },
    closeDig() {
      this.$refs.sensitivemultipleTable.clearSelection();
    },
    //删除角色
    delRole(group_id) {
      this.$confirm("您确定删除该角色？", "提示消息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          system
            .delAdminGroup({ group_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("删除成功");
                if (!(this.tableData.length - 1) % this.pagesize) {
                  this.currentPage =
                    this.currentPage == 1 ? 1 : this.currentPage - 1;
                }
                this.getAdminGroup();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    //权限设置
    setRole(row) {
      this.$router.push({
        path: "setrole",
        query: {
          group_id: row.group_id,
          group_name: row.group_name,
          module_id_array: row.module_id_array,
        },
      });
    },
    //查看角色关联的用户
    roleNum(group_id) {
      this.rolenum = true;
      system
        .adminRoleList({ group_id })
        .then((res) => {
          if (res.code == 0) {
            this.adminList = res.data.list;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //查看系统管理员的角色权限
    checkRole() {
      this.$router.push("checkrole");
    },
  },

  created() {
    this.getAdminGroup();
    this.getConfig();
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
}

.myform {
  width: 500px;
  padding-top: 20px;
}
.rolenum {
  color: #669961;
  cursor: pointer;
}
.adminbox {
  text-align: left;
  min-height: 300px;
}
.admintitle {
  display: flex;
  background: #f5f5f5;
  padding: 0 20px;
  height: 35px;
  line-height: 35px;
  box-sizing: border-box;
  color: #262626;
  .name {
    width: 140px;
  }
  .desc {
    flex: 1;
    text-align: center;
    margin: 0 15px;
  }
  .statu {
    width: 100px;
  }
}
.adminitem {
  display: flex;
  padding: 0 20px;
  line-height: 48px;
  box-sizing: border-box;
  color: #262626;
  border-bottom: 1px solid #e8e9f0;
  .name {
    width: 140px;
  }
  .desc {
    flex: 1;
    text-align: center;
    margin: 0 15px;
  }
  .statu {
    width: 100px;
  }
}
</style>
<style lang="scss">
.mydialog .el-dialog__body {
  padding: 0px !important;
}
.el-form-item__content {
  height: auto;
}
</style>
